import React from "react"
import { useState } from 'react'
import CMSRender from "aldoo-ra/CMS/cms-render"
import Button from "aldoo-ra/Button"
import Typography from "aldoo-ra/Typography"
import { navigate } from "vike/client/router"
import parse from "html-react-parser"


const ActivationCard = () => {
  const [codePart1, setCodePart1] = useState('');
  const [codePart2, setCodePart2] = useState('');

  const buttonVariant = codePart1 && codePart2 ? "primary_s" : "primary_s_disabled";

  const handleActivate = () => {
    alert(`Activation Code: ${codePart1}-${codePart2}`);
  };

  return (
    <CMSRender
      contentType="AccountSupportCard"
      match={{ "content.name": "ActivationCard" }}
      renderItem={(card) => {
        return (
          <div className="w-full max-w-[554px] flex flex-col  items-start justify-between bg-paper rounded-[50px] gap-5 md:gap-0 px-[40px] py-[35px] shadow-card_shadow">
            {/* Title */}
            <Typography 
              variant="h3" 
              className="text-text text-left mb-[25px]"
            >
              {card.title}
            </Typography>

            {/* Activation Code Input */}
            <div className="flex items-center justify-center space-x-2 mb-6">
              <input
                type="text"
                maxLength="6"
                value={codePart1}
                onChange={(e) => setCodePart1(e.target.value)}
                className="w-[208px] h-[56px] text-center border border-bordered rounded-full focus:outline-none focus:ring-2 focus:ring-primary text-gray_700"
                placeholder="XXXXXX"
              />

              <span className="text-xl text-gray_700">—</span>

              <input
                type="text"
                maxLength="6"
                value={codePart2}
                onChange={(e) => setCodePart2(e.target.value)}
                className="w-[208px] h-[56px] text-center border border-bordered rounded-full focus:outline-none focus:ring-2 focus:ring-primary text-gray_700"
                placeholder="XXXXXX"
              />
            </div>

            <Button 
              variant={buttonVariant} disabled={!codePart1 || !codePart2}
            >
              {card.cta[0].label}
            </Button>
          </div>
        );
      }}
    />
  );
};

export default ActivationCard;
